//adpoted from https://github.com/the-road-to-learn-react/use-data-api/blob/master/src/index.js
import { useState, useEffect, useReducer } from "react";

const dataFetchReducer = (state, action) => {
  switch (action.type) {
    case "FETCH_INIT":
      return { ...state, isLoading: true, isError: false };
    case "FETCH_SUCCESS":
      return {
        ...state,
        isLoading: false,
        isError: false,
        data: action.payload
      };
    case "FETCH_FAILURE":
      return {
        ...state,
        isLoading: false,
        isError: true,
        errorData: action.payload
      };
    default:
      throw new Error();
  }
};

const useDataApi = (serviceInstance, axiosConfig, initialData = {}) => {
  const [serviceConfig, setServiceConfig] = useState(axiosConfig);
  const [state, dispatch] = useReducer(dataFetchReducer, {
    isLoading: false,
    isError: false,
    data: initialData,
    errorData: false
  });

  useEffect(() => {
    let didCancel = false;

    const fetchData = async () => {
      //if passed in a null serviceConfig, we don't want to run an api call on init
      if (serviceConfig === null) return;

      dispatch({ type: "FETCH_INIT" });

      try {
        const result = await serviceInstance(serviceConfig);
        if (!didCancel) {
          dispatch({ type: "FETCH_SUCCESS", payload: result.data });
        }
      } catch (error) {
        //for network errors that were not able to connect, there won't
        //be a network response, need to construct the payload
        if (!error.response) {
          error.response = {
            data: { message: error.message, url: error.config.url }
          };
        }
        if (!didCancel) {
          dispatch({ type: "FETCH_FAILURE", payload: error.response });
        }
      }
    };

    fetchData();

    return () => {
      didCancel = true;
    };
  }, [serviceInstance, serviceConfig]);

  return [state, setServiceConfig];
};

export default useDataApi;
